// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'wiring-error.title',
        defaultMessage: 'Wiring error!'
    },
    subheading: {
        id: 'wiring-error.subheading',
        defaultMessage: 'Please try the following steps in order.'
    },
    refresh: {
        id: 'wiring-error.refesh',
        defaultMessage: 'Refresh'
    },
    step1: {
        id: 'wiring-error.step1',
        defaultMessage: '1. Go to your thermostat'
    },
    step2: {
        id: 'wiring-error.step2',
        defaultMessage: '2. Take the thermostat body off the wall'
    },
    step3: {
        id: 'wiring-error.step3',
        defaultMessage: '3. Check the wires are in the correct terminals'
    },
    step4: {
        id: 'wiring-error.step4',
        defaultMessage: '4. Replace the thermostat body'
    },
    step5: {
        id: 'wiring-error.step5',
        defaultMessage: '5. Press check on the thermostat (if the wires are correct) and tap refresh'
    },
    extendedSupport: {
        id: 'wiring-error.extended-support',
        defaultMessage: 'If the above steps have not helped please check hivehome.com for our support hours.'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/wiring-error/intl.js